import { LocalizationProvider, ptBR } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";

export default function DatePickerLocalizationAdapter(props: {
  children: React.ReactNode;
}) {
  return (
    <LocalizationProvider
      localeText={
        ptBR.components.MuiLocalizationProvider.defaultProps.localeText
      }
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-BR"
    >
      {props.children}
    </LocalizationProvider>
  );
}

